import OrganizationManagerEdit from './OrganizationManagerEdit';

export default OrganizationManagerEdit;
